var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switch-field',{attrs:{"label":_vm.$t('Required Terms of Service')},model:{value:(_vm.isRequired),callback:function ($$v) {_vm.isRequired=$$v},expression:"isRequired"}})}
var staticRenderFns = []

export { render, staticRenderFns }